export const SalesforceFieldMaxLength = 255;

export type ErrorType = 'required' | 'invalid' | 'select_required' | 'digits' | 'max_length' | 'in_use';
export type WarningType = 'unavailable';

export type AddressType = 'billing' | 'service' | 'shipping';
export type ContactType = 'onboarding' | 'admin' | 'shipping' | 'billing';

export interface IInputValue<InputValueType> {
  value: InputValueType;
  errorType?: ErrorType;
  warningType?: WarningType;
}

export interface IAddress {
  address: IInputValue<string>;
  secondaryAddress: IInputValue<string | null>;
  neighborhood: IInputValue<string | null>;
  streetNumber: IInputValue<string | null>;
  apartment: IInputValue<string | null>;
  floor: IInputValue<string | null>;
  withoutNumber: IInputValue<boolean>;
  recipient: IInputValue<string | null>;
  city: IInputValue<string>;
  state: IInputValue<string>;
  zipCode: IInputValue<string>;
  country: IInputValue<string>;
  autocompleteShortAddress: IInputValue<string | null>;
  autocompleteInputAddress: IInputValue<string | null>;
  autocompleteSelectedAddress: IInputValue<string | null>;
}

export interface IContact {
  uiKey: string;
  firstName: IInputValue<string>;
  lastName: IInputValue<string>;
  email: IInputValue<string>;
  phoneNumber: IInputValue<string>;
}
